import { render, staticRenderFns } from "./FormulaAdditionalRaw.vue?vue&type=template&id=54023fce&scoped=true"
import script from "./FormulaAdditionalRaw.vue?vue&type=script&lang=js"
export * from "./FormulaAdditionalRaw.vue?vue&type=script&lang=js"
import style0 from "./FormulaAdditionalRaw.vue?vue&type=style&index=0&id=54023fce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54023fce",
  null
  
)

export default component.exports